export const ICONS = {
  chevron_down: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6.5L8 10.5L12 6.5"
        stroke="#357960"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  chevron_up: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5L8 6.5L4 10.5"
        stroke="#357960"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  chevron_right: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.3333 8.5H12.6666"
        stroke="#357960"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 3.83337L12.6667 8.50004L8 13.1667"
        stroke="#357960"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const BATCH_META_FIELDS__EXPANDED = [
  {
    key: "batch_name",
    label: "Batch",
  },
  {
    key: "start_date",
    label: "Starting From",
  },
  {
    key: "mentors",
    label: "Mentors",
  },
  {
    key: "timings",
    label: "Timings",
  },
];

export const BATCH_META_FIELDS__COMPACT = [
  ...BATCH_META_FIELDS__EXPANDED,
].splice(0, 2);

export const SELF_PACED_BATCH_META_FIELDS = [
  {
    key: "reg_start_date",
    label: "Starting From",
  },
];

export const BATCH_META_FIELDS = [
  {
    key: "start_date",
    label: "Starting From",
  },
  {
    key: "offline_course_location",
    label: "Location",
  },
];

export const MONGODB_BATCH_SLUG =
  "mongodb-developers-toolkit-crud-mastery-nodejs";
